import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

const NormalizePath = () => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const normalizedPath = location.pathname.replace(/\/{2,}/g, '/');
    if (normalizedPath !== location.pathname) {
      navigate(normalizedPath + location.search, { replace: true });
    }
  }, [location, navigate]);

  return null;
};
export default NormalizePath;
